import {UserRole} from 'classes/user-role';
import {Category} from 'shared/models/target-groups/category';
import {Company} from 'shared/models/target-groups/company';
import {Group} from 'shared/models/target-groups/group';
import {ManagementLevel} from 'shared/models/target-groups/management-level';

export class TargetGroup {
  public _id?: string;
  public title: string;
  public roles?: Array<UserRole>;
  public categories?: Array<Category>;
  public groups?: Array<Group>;
  public sex?: string;
  public managementLevel?: Array<ManagementLevel>;
  public minAge?: number;
  public maxAge?: number;
  public companies?: Array<Company>;
  public firstOrderTips?: Array<number>;
  public onlyExplAssContents?: boolean;

  constructor() {
    this.title = '';
    this.companies = [];
    this.managementLevel = [];
    this.roles = [];
    this.categories = [];
    this.roles = [];
    this.groups = [];
  }
}

export const COURSE_DUMMY = 'KursImpulseDummy';
export const QUESTIONNAIRE_DUMMY = 'FragebogenDummy';

export const TARGETGROUP_DUMMIES = [COURSE_DUMMY, QUESTIONNAIRE_DUMMY];



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/target-groups/target-group.ts